import { LibraryItemTypes } from '../store/enums'
import { Privilege } from '@app/core/model/enums/privilege.enum'

export const LibraryItemPrivileges = {
  [LibraryItemTypes.DELIVERABLE]: Privilege.LIBRARY_DELIVERABLE__EDIT,
  [LibraryItemTypes.COMPONENT]: Privilege.LIBRARY_COMPONENT__EDIT,
  [LibraryItemTypes.THIRD_PARTY_COST]: Privilege.LIBRARY_THIRD_PARTY_COST__EDIT,
  [LibraryItemTypes.FOLDER]: Privilege.LIBRARY_FOLDER__EDIT,
}
